import { AbstractService } from "./abstract.service";
import FileDownload from "js-file-download";
import moment from "moment";

export class ProductService extends AbstractService {
  static get entity() {
    return "proxy-gateway/gw-core";
  }
  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  /** * * * * * * * * *
   * * Item-compound * *
   ** * * * * * * * * */

  static async getListv1(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/item-compound/search`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getList(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/item-compound/search-v2`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getListItemOfBE(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/item/search-query-string`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getTotalProducts(params) {
    try {
      const res = await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/item/items/count`,
        params
      );
      return this.responseWrapper(res,res.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async countItems(search) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/item-compound/count`,
        search
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  // get item detail old
  static async getItem(itemId) {
    try {
      const response = await this.callApi().get(
        `${this.entity}/item-compound/${itemId}`
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  //get item detail new
  static async getDetailItem(params) {
    try {
      const response = await this.callApi().post(`${this.URL_GATEWAY}/nsh/item/items/compound`, params);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  /** * * * * * * * **
   * * * * Item * * * *
   ** * * * * * * * **/

  static async getProductDetail(itemId) {
    try {
      const response = await this.callApi().get(
        `${this.entity}/item/${itemId}`
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createItem(params) {
    try {
      const response = await this.callApi().post(`${this.URL_GATEWAY}/nsh/item/items`, params);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateItem(params) {
    try {
      const response = await this.callApi().patch(`${this.URL_GATEWAY}/nsh/item/items`, params);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  /** * * * * * * **
   * * Item-price * *
   ** * * * * * * **/

  static async createPrice(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/item-price`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updatePrice(params, id) {
    try {
      const response = await this.callApi().patch(
        `${this.entity}/item-price/${id}`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getPriceVersionToUpdate(id) {
    try {
      const response = await this.callApi().get(
        `${this.entity}/item-price/${id}`
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async exportData(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/imexport/api/product-item/export`, params, {responseType: 'blob'}
      )

      FileDownload(response.data, 'Report-products' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')

      return this.responseWrapper(response, response);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async importData(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/iex/api/item/upload-data`, params
      )
      return this.responseWrapper(response, response);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getProductSeriesEmei(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entity}/product-series/search`, params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getProductBatch(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entity}/product-batch/search-dynamic`, params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getProductBatchAutoSelectBatch(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entity}/product-batch/auto-select-batch`, params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async archiveOneItem(id, params) {
    try {
      const response = await this.callApi().delete(`${this.URL_GATEWAY}/nsh/item/items/${id}`, {data: params});
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async archiveManyItem(params) {
    try {
      const response = await this.callApi().delete(`${this.URL_GATEWAY}/nsh/item/items`, {data: params});
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
}
